import { chooseDBTranslation } from 'utils/translations'
import { Paragraph, TextRun } from 'docx'
import { CVData } from 'types/printInterfaces'
import { IHideSetting } from 'types/layoutInterfaces'
import { isDetailHidden } from '../hideSettings'
import { itemHeading, itemHeadingTabStops, itemParagraphSpacing } from './itemHeading'
import { fontSize } from './pageLayout'
import { convertToDisplayDate } from 'utils/utils'
import { i18n, TFunction } from 'i18next'

const leisureActivity = (i18n: i18n, data: CVData, t: TFunction, hideSetting?: IHideSetting): Paragraph[] => {
  const activities: Paragraph[] = []

  for (let i = 0; i < data.leisureActivities.length; i++) {
    const item = data.leisureActivities[i]
    const tr = chooseDBTranslation(i18n, item)

    let date = ''
    if (item.startDate) {
      date += `${convertToDisplayDate(item.startDate, item.dateResolution)} - `
    }
    if (item.endDate) {
      date += `${convertToDisplayDate(item.endDate, item.dateResolution)}`
    }

    activities.push(
      new Paragraph({
        keepLines: true,
        style: 'CaleoNormal',
        tabStops: itemHeadingTabStops,
        spacing: itemParagraphSpacing,
        children: [
          ...itemHeading(
            isDetailHidden(hideSetting, 'name') ? '' : (tr?.name ?? ''),
            isDetailHidden(hideSetting, 'date') ? '' : date
          ),
          ...(tr?.activityType && !isDetailHidden(hideSetting, 'activityType')
            ? [
                new TextRun({ text: `${t('print.leisureActivities.type')}: `, bold: true, break: 1 }),
                new TextRun({ text: tr.activityType }),
              ]
            : []),
          ...(isDetailHidden(hideSetting, 'description')
            ? []
            : [new TextRun({ text: tr?.description ?? '', size: fontSize.small, break: 1 })]),
        ],
      })
    )
  }

  return activities
}

export default leisureActivity
